import {LikeIcon, BookmarkIcon, CommentIcon, FollowingIcon, MessageIcon} from '../../icons'

export const notifTypes = [
    {key: 'like',    valueKey: 'like_count',    color: 'red',     icon: <LikeIcon size={11}/>},
    {key: 'save',    valueKey: 'save_count',    color: 'yellow',  icon: <BookmarkIcon size={10}/>},
    {key: 'comment', valueKey: 'comment_count', color: 'blue',    icon: <CommentIcon size={10}/>},
    {key: 'follow',  valueKey: 'follow_count',  color: 'primary', icon: <FollowingIcon size={11}/>},
    {key: 'message', valueKey: 'message_count', color: 'tertiary', icon: <MessageIcon size={10}/>, url: '/network/messages'},
]

export const menuProfileKeys = ['like', 'save', 'comment']
export const menuNetworkKeys = ['follow', 'message']
export const notificationsKeys = ['like', 'save', 'comment', 'follow']
export const networkKeys = ['follow', 'message']
export const toolbarKeys = [...menuProfileKeys, ...menuNetworkKeys]

export const slots = {
    toolbars: {
        profile: {
            mobile: [
                {top: -32, right: 24},
                {top: -24, left: 200, center: 'left'},
                {top: 6,   left: 212, center: 'left'},
            ],
            desktop: [
                {top: -122, right: 24},
                {top: -56, right: 24},
                {top: -26, right: 24},
            ],
            desktopProfilePath: [
                {top: -106, right: 24},
                {top: -76, right: 24},
                {top: -46, right: 24},
            ],
        },
        network: {
            mobile: [
                {top: -32, right: 60},
                {top: -32, right: 96},
            ],
            mobileSingle: [
                {top: -32, right: 77},
            ],
            desktop: [
                {top: -122, right: 73},
                {top: -56, right: 73},
            ],
            desktopProfilePath: [
                {top: -106, right: 73},
                {top: -76, right: 73},
            ],
        },
    },
    notifications: {
        mobile: [
            {top: 36,  right: 19},
            {top: 20,  left: 40, center: 'left'},
            {top: -14, left: 40, center: 'left'},
            {top: -30, right: 18},
        ],
        desktop: [
            {top: -32,  right: 19},
            {top: -14, left: 40, center: 'left'},
            {top: 20,  left: 40, center: 'left'},
            {top: -32, right: 44, center: 'right'},
        ],
    },
    network: {
        mobile: [
            {top: 6,  right: -40},
            {top: 36,  right: -26},
        ],
        desktop: [
            {slotKey: 'message', top: 4,  right: -202},
            {slotKey: 'follow', top: 4,  right: -153},
        ],
        desktopProfilePath: [
            {slotKey: 'message', top: 4,  right: -202},
            {slotKey: 'follow', top: 4,  right: -153},
        ],
    },
}
